import { useEffect, useState } from "react";

let pendingVisit;
let memoryId;
function recordVisit() {
  if (pendingVisit) return pendingVisit;
  let visitId = memoryId;
  try { visitId = sessionStorage.getItem("ca-visit-id") || visitId; } catch {}
  visitId = visitId || crypto.randomUUID();
  memoryId = visitId;
  try { sessionStorage.setItem("ca-visit-id", visitId); } catch {}
  const base = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 60000);
  pendingVisit = fetch(base + "/api/visits", {
    signal: controller.signal,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ visit_id: visitId }),
  }).then(async response => {
    if (!response.ok) throw new Error("Visit counter unavailable");
    const data = await response.json();
    if (!Number.isSafeInteger(data.visits) || data.visits < 0) throw new Error("Invalid total");
    return data.visits;
  }).catch(error => { pendingVisit = undefined; throw error; }).finally(() => clearTimeout(timeout));
  return pendingVisit;
}

export default function VisitCounter() {
  const [visits, setVisits] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let active = true;
    recordVisit().then(total => { if (active) setVisits(total); })
      .catch(() => { if (active) setFailed(true); });
    return () => { active = false; };
  }, []);
  return (
    <div className="mt-10 text-sm text-[#8E95A5]" aria-live="polite">
      <p>Site visits: <span className="text-[#F0F2F8]">{visits !== null
        ? visits.toLocaleString() : failed ? "Unavailable" : "Loading…"}</span></p>
      <p className="mt-1 text-xs">Since counter launch · One visit per browser-tab session.
        Repeat visitors may count again. No IP addresses stored by this counter.</p>
    </div>
  );
}
